 <div class=" card card-stats animate stroke">
    <div class=" card-body">
      <div class=" row">
        <div class=" col">
          <h5 class=" card-title text-uppercase text-muted mb-0">
            
          </h5>

          <span class=" h2 font-weight-bold mb-0"> </span>
        </div>

        <div class=" col-auto">
          <div class=" icon icon-shape bg-gradient-gray text-white rounded-circle shadow">
           
            <!-- <i class=" ni ni-active-40"> </i> -->
          </div>
        </div>
      </div>

      <p class=" mt-3 mb-0 text-sm">
        <span class=" text-success mr-2">
          <!-- <i class=" fa fa-arrow-up"> </i>  -->
          
        </span>

        <span class=" text-danger text-nowrap">  </span>
        
      </p>

    </div>
 </div>